import axios from 'axios';

const getFactsApi = () => {
	return axios.get('https://backend.planmyleisure.com/blog/get-facts');
};

export default getFactsApi;
